import { Action, createReducer, on } from '@ngrx/store';
import * as destinationActions from '../actions/index'; // Adjust the import path as needed
import { produceOn } from '../../immer.helper';

// Define the state interface
export interface DestinationsState {
  destinations?: any[];
  domesticDestinations?: any[];
  internationalDestinations?: any[];
  selectedDestination?: any; // Property to store the selected destination
  isLoading?: boolean;
  error?: any;
}

// Define the initial state
export const initialState: DestinationsState = {
  destinations: [],
  domesticDestinations: [],
  internationalDestinations: [],
  selectedDestination: null, // Initialize the selected destination as null
  isLoading: false,
  error: null,
};

// Create the reducer using Immer's produceOn to handle state mutations
const destinationsReducer = createReducer(
  initialState,
  // Handle getting all destinations
  produceOn(destinationActions.getDestinations, (draft) => {
    draft.isLoading = true;
    draft.error = null;
  }),
  produceOn(destinationActions.getDestinationsSuccess, (draft, { data }) => {
    draft.destinations = data;
    draft.isLoading = false;
  }),
  produceOn(destinationActions.getDestinationsFailure, (draft, { error }) => {
    draft.isLoading = false;
    draft.error = error;
  }),

  // Handle getting a destination by ID
  produceOn(destinationActions.getDestinationById, (draft) => {
    draft.isLoading = true;
    draft.error = null;
    draft.selectedDestination = null; // Reset selected destination on new request
  }),
  produceOn(destinationActions.getDestinationByIdSuccess, (draft, { data }) => {
    draft.selectedDestination = data;
    draft.isLoading = false;
  }),
  produceOn(
    destinationActions.getDestinationByIdFailure,
    (draft, { error }) => {
      draft.isLoading = false;
      draft.error = error;
    }
  ),

  // Handle clearing the selected destination
  produceOn(destinationActions.clearSelectedDestination, (draft) => {
    draft.selectedDestination = null; // Clear the selected destination
    draft.isLoading = false; // Optionally reset loading state
    draft.error = null; // Optionally clear any errors
  }),

  // Handle getting domestic destinations
  produceOn(destinationActions.getDomesticDestinations, (draft) => {
    draft.isLoading = true;
    draft.error = null;
  }),
  produceOn(
    destinationActions.getDomesticDestinationsSuccess,
    (draft, { data }) => {
      draft.domesticDestinations = data;
      draft.isLoading = false;
    }
  ),
  produceOn(
    destinationActions.getDomesticDestinationsFailure,
    (draft, { error }) => {
      draft.isLoading = false;
      draft.error = error;
    }
  ),

  // Handle getting international destinations
  produceOn(destinationActions.getInternationalDestinations, (draft) => {
    // draft.isLoading = true;
    // draft.error = null;
  }),
  produceOn(
    destinationActions.getInternationalDestinationsSuccess,
    (draft, { data, category }) => {
      draft.internationalDestinations = data;
      // draft.isLoading = false;
    }
  ),
  produceOn(
    destinationActions.getInternationalDestinationsFailure,
    (draft, { error, category }) => {
      // draft.isLoading = false;
      // draft.error = error;
    }
  )
);

// Export the reducer function
export function reducer(
  state: DestinationsState | undefined,
  action: Action
): DestinationsState {
  return destinationsReducer(state, action);
}
